import { render, staticRenderFns } from "./ReceiptForm.vue?vue&type=template&id=0891ab4a&scoped=true"
import script from "./ReceiptForm.vue?vue&type=script&lang=ts"
export * from "./ReceiptForm.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptForm.vue?vue&type=style&index=0&id=0891ab4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891ab4a",
  null
  
)

export default component.exports